module.exports = __webpack_public_path__ + "img/09.c9263cb5.jpg";